<template>
    <div class="">
        <div class="title mb-5 has-text-weight-bold">Profile URL</div>

        <FormErrors v-bind:errors="fields.errors.detail" />

        <div class="field">
            <label class="label">Profile URL</label>
            <div class="control">
                <div v-if="allow_editing">
                    <InputBox type="text" v-model="fields.profile_url"/>
                    <!-- {{ profile_url }} -->
                </div>
                <div v-else class="box is-rounded p-3">
                    <div v-if="fields.profile_url">
                        <a target="_blank" :href="profile_url">{{ fields.profile_url }}</a>
                    </div>
                    <div v-else>
                        No data
                    </div>
                </div>
                <FormErrors v-bind:errors="fields.errors.designation" />
            </div>
        <div class="field">
            <label class="label m-2">Organization</label>
            <div class="control">
                <div v-if="allow_editing">
                    <InputBox type="text" v-model="fields.organization"/>
                    <!-- {{ profile_url }} -->
                </div>
                <div v-else class="box is-rounded p-3">
                    <div v-if="fields.organization">
                        <a target="_blank" :href="organization">{{ fields.organization }}</a>
                    </div>
                    <div v-else>
                        No data
                    </div>
                </div>
            </div>  
            <div v-if="allow_editing" class="control pt-2">
                <button v-on:click="save" class="button is-fullwidth is-primary has-text-weight-bold">
                    Save Changes
                </button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from '../../api/my-axios';
import FormErrors from '../FormHelpers/FormErrors';
import InputBox from '../FormHelpers/InputBox';

export default {
    components: {
        InputBox,
        FormErrors,
    },
    props: {
        is_editable: {
            type: Boolean,
            default: false,
        },
        profile_uid: {
            type: String,
            default: null,
        },
        user_role: {
            // "mentor" or "mentee"
            type: String,
            default: null,
        },
        profile_url: {
            type: String,
            default: null
        },
        organization: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapState({
            user: 'user',
        }),
        ...mapGetters({
            role: 'role', // "mentor" or "mentee"
        }),
    },
    data() {
        return {
            allow_editing: false,
            to_show_user_role: this.user_role,
            to_show_profile_uid: this.profile_uid,

            fields: {
                request_token: {
                    // mentor or mentee: ""
                },

                options: {
                    profile_url: "",
                    organization: "",
                },
                errors: {
                    detail: '',
                    designation: '',
                },
                organization: '',
                profile_url: '',
            },
        };
    },
    created() {
        // TODO Try to fetch all three field options in one-go
        /* TODO Due to concurrent requests, selected options part may run before all options have been fetched
         * leading to empty boxes. Use promises (axios.all()) or async-await to ensure proper run order
         * */

        this.to_show_profile_uid = this.profile_uid
            ? this.profile_uid
            : this.user.profile_uid;
        this.to_show_user_role = this.user_role ? this.user_role : this.role;
        this.allow_editing = this.is_editable
            ? this.to_show_profile_uid === this.user.profile_uid
            : false;

        // this.get_field_options();
        this.get_currently_selected_options();
    },
    methods: {
        get_field_options() {
            for (const field in this.fields.options) {
                axios
                    .get(`/api/${this.to_show_user_role}/${field}/`)
                    .then((response) => {
                        this.fields.options[field] = response.data;
                    })
                    .catch((error) => {
                        this.fields.errors[field] = error.response
                            ? error.response.data
                            : { detail: [error.message] };
                    });
            }
        },

        get_currently_selected_options() {
            axios
                .get(
                    `/api/${this.to_show_user_role}/${this.to_show_user_role}/${this.to_show_profile_uid}/`
                )
                .then((response) => {
                    // Response contains the selected UIDs

                    // for (const field in this.fields.options) {
                    //     this.fields.selected[field] = response.data[field];

                    //     const obj = this.fields.options[field].find(
                    //         (e) => e.uid === response.data[field]
                    //     );
                    //     this.fields.selected[field].value = obj ? obj.label : '';
                    // }
                    this.fields.profile_url = response.data['profile_url'];
                    this.fields.organization = response.data['organization'];
                    // this.fields.selected.specialization.value =
                    //     response.data.specialization;
                })
                .catch((error) => {
                    this.fields.errors = error.response
                        ? error.response.data
                        : { detail: [error.message] };
                });
        },

        save() {
            if (!this.allow_editing) {
                return;
            }
            axios
                .patch(`/api/${this.role}/${this.role}/${this.user.profile_uid}/`, {
                    organization: this.fields.organization,
                    profile_url: this.fields.profile_url,   
                })
                .then(() => {
                    this.$store.commit("set_show_alert", {show: true, message: 'Profile URL updated', type: 'success'});
                    setTimeout(() => {
                        this.$store.commit("set_show_alert", {show: false, message: '', type: 'success '});
                    }, 1000);
                })
                .catch((error) => {
                    this.fields.errors = error.response
                        ? error.response.data
                        : { detail: [error.message] };
                });
        },
    },
};
</script>
